



































import { mapGetters } from 'vuex';

export default {
	name: 'MakeOfferWizard',

	setup() {},

	computed: {
		...mapGetters('offerModule', {
			currentStep: 'getCurrentStep',
		}),
		steps() {
			return [
				{
					name: 'Job Details',
					step: 1,
					active: this.currentStep === 1,
					completed: this.currentStep > 1,
				},
				{
					name: 'Salary',
					step: 2,
					active: this.currentStep === 2 || this.currentStep === 3,
					completed: this.currentStep > 3,
				},
				{
					name: 'Deciding Factors',
					step: 4,
					active: this.currentStep === 4,
					completed: this.currentStep > 4,
					last: true,
				},
			];
		},
	},

	methods: {
		goToStep(step) {
			this.$store.dispatch('offerModule/setCurrentStep', step);
		},
	},
};
